import {
  readTenantIdentity,
  resolveTenantForWorkspace,
} from './demoTenants';
import { getWorkspace, isWorkspaceId } from './workspaces';

export const DEMO_SESSION_STORAGE_KEY = 'evault.demoSession';

function storage() {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return null;
  }
  return window.sessionStorage;
}

function sessionFromTenant(workspace, tenant, env) {
  const identity = readTenantIdentity(tenant.id, env);
  const userId = identity.configured ? identity.userId : null;
  const orgId = identity.configured ? identity.orgId : null;
  return {
    workspaceId: workspace.id,
    tenantId: tenant.id,
    role: workspace.role,
    organizationName: tenant.organizationName,
    roleLabel: workspace.roleLabel,
    userDisplayName: tenant.userDisplayName,
    initials: tenant.initials,
    userId,
    orgId,
    configured: Boolean(userId && orgId),
    // Header-mode demo matches backend: treat the seeded actor as org admin.
    membershipRole: 'admin',
    permissions: [],
    isPlatformAdmin: false,
  };
}

export function createDemoSession(workspaceId, tenantId, env) {
  const workspace = getWorkspace(workspaceId);
  if (!workspace) {
    return null;
  }
  const tenant = resolveTenantForWorkspace(workspaceId, tenantId);
  if (!tenant) {
    return null;
  }
  return sessionFromTenant(workspace, tenant, env);
}

function normalizeSession(value) {
  if (!value || !isWorkspaceId(value.workspaceId)) {
    return null;
  }
  const workspace = getWorkspace(value.workspaceId);
  const tenant = resolveTenantForWorkspace(workspace.id, value.tenantId);
  if (!workspace || !tenant) {
    return null;
  }
  return sessionFromTenant(workspace, tenant);
}

export function readDemoSession() {
  const store = storage();
  if (!store) return null;
  try {
    const raw = store.getItem(DEMO_SESSION_STORAGE_KEY);
    if (!raw) return null;
    return normalizeSession(JSON.parse(raw));
  } catch {
    return null;
  }
}

export function writeDemoSession(session) {
  const store = storage();
  const normalized = normalizeSession(session);
  if (!store || !normalized) {
    return null;
  }
  store.setItem(DEMO_SESSION_STORAGE_KEY, JSON.stringify(normalized));
  return normalized;
}

export function clearDemoSession() {
  const store = storage();
  if (store) {
    store.removeItem(DEMO_SESSION_STORAGE_KEY);
  }
}
